export default __webpack_public_path__ + "static/demo-7160cfd56ad027c7ca8cd2ac88d408db.png";